import { $api } from "@/lib/api-client";

export const useFetchAvailableBySlot = (
  projectId: string,
  type: number | null,
) => {
  return $api.useQuery(
    "get",
    "/nft/available/{projectId}",
    {
      params: {
        path: { projectId: projectId },
        query: { type: type! },
      },
    },
    {
      refetchInterval: false,
      refetchIntervalInBackground: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      enabled: !!type,
    },
  );
};
